import React, { useState } from "react";
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";

import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

import CreateContractItem from "../popUpComponents/CreateEditContractItem/CreateContractItem";
import CreateSupplier from "../popUpComponents/CreateSupplier/CreateSupplier";
import CreateEditCustomer from "../popUpComponents/CreateEditCustomer/CreateEditCustomer";
import CreateEditTaskPopUp from "../popUpComponents/CreateEditTask/CreateEditTaskPopUp";
import CreateEditOpportunityPopUp from "../popUpComponents/CreateNewOpportunity/CreateNewOpportunity";
import JobCreateEdit from "../popUpComponents/JobCreateEdit";
import UploadMultipleFiles from "../popUpComponents/uploadMultipleFiles";
import { SendEmail } from "../Common/SendEmail";
import LeaveRequest from "../popUpComponents/LeaveRequest/leaveRequest";
import SendSms from "../popUpComponents/SendSms";


const myShortCutsList = [
  {
    Id: 1,
    Title: "Job",
    Icon: "fa-solid fa-clipboard-list",
    Active: true,
  },
  {
    Id: 2,
    Title: "Task",
    Icon: "fa-solid fa-list-check",
    Active: true,
  },
  {
    Id: 3,
    Title: "Customer",
    Icon: "fa-solid fa-people-line",
    Active: true,
  },
  {
    Id: 4,
    Title: "Supplier",
    Icon: "fa-solid fa-house-laptop",
    Active: true,
  },
  {
    Id: 5,
    Title: "Opportunity",
    Icon: "fa-solid fa-timeline",
    Active: true,
  },
  {
    Id: 6,
    Title: "Invoice",
    Icon: "fa-solid fa-file-pdf",
    Active: true,
  },
  {
    Id: 7,
    Title: "Purchase",
    Icon: "fa-solid fa-basket-shopping",
    Active: true,
  },
  {
    Id: 8,
    Title: "Contract",
    Icon: "fa-regular fa-file",
    Active: true,
  },
  {
    Id: 9,
    Title: "Upload Files",
    Icon: "fa-solid fa-file-upload",
    Active: true,
  },
  {
    Id: 10,
    Title: "Email",
    Icon: "fa-solid fa-envelope",
    Active: true,
  },
  {
    Id: 11,
    Title: "SMS",
    Icon: "fa-solid fa-comment-sms",
    Active: true,
  },
  {
    Id: 12,
    Title: "Leave Request",
    Icon: "fa-regular fa-calendar-plus",
    Active: true,
  },
  {
    Id: 13,
    Title: "Create Quote",
    Icon: "fa-regular fa-rectangle-list",
    Active: true,
  },
  {
    Id: 14,
    Title: "Upload Purchase",
    Icon: "fa-solid fa-file-invoice",
    Active: true,
  },
];

export default function MyShortCuts() {
  const history = useHistory();

  const [isMyShortCutsDropdown, setIsMyShortCutsDropdown] = useState(false);

  const [moduleCreateJob, setModuleCreateJob] = useState(false);
  const [moduleCreateTask, setModuleCreateTask] = useState(false);
  const [moduleCreateCustomer, setModuleCreateCustomer] = useState(false);
  const [moduleCreateSupplier, setModuleCreateSupplier] = useState(false);
  const [moduleCreateOpportunity, setModuleCreateOpportunity] = useState(false);
  const [moduleCreateContract, setModuleCreateContract] = useState(false);
  const [moduleUploadFiles, setModuleUploadFiles] = useState(false);
  const [moduleUploadPurchase, setModuleUploadPurchase] = useState(false);
  const [moduleCreateEmail, setModuleCreateEmail] = useState(false);
  const [moduleCreateSms, setModuleCreateSms] = useState(false);
  const [modalLeaveRequest, setModalLeaveRequest] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const toggleIsMyShortCutsDropdown = () => {
    setIsMyShortCutsDropdown((prev) => !prev);
  };

  const toggleModuleCreateJob = () => {
    setModuleCreateJob((prev) => !prev);
  };

  const toggleModuleCreateTask = () => {
    setModuleCreateTask((prev) => !prev);
  };

  const toggleModuleCreateCustomer = () => {
    setModuleCreateCustomer((prev) => !prev);
  };

  const toggleModuleCreateSupplier = () => {
    setModuleCreateSupplier((prev) => !prev);
  };

  const toggleModuleCreateOpportunity = () => {
    setModuleCreateOpportunity((prev) => !prev);
  };

  const toggleModuleCreateContract = () => {
    setModuleCreateContract((prev) => !prev);
  };

  const toggleModuleUploadFiles = () => {
    setModuleUploadFiles((prev) => !prev);
  };

  const toggleModuleUploadPurchase = () => {
    setModuleUploadPurchase((prev) => !prev);
  };

  const toggleModuleCreateEmail = () => {
    setModuleCreateEmail((prev) => !prev);
  };

  const toggleModuleCreateSms = () => {
    setModuleCreateSms((prev) => !prev);
  };

  const toggleLeaveRequest = () => {
    setModalLeaveRequest((prev) => !prev);
  };

  const handleShortCutCLick = (item) => {
    setIsMyShortCutsDropdown(false);

    switch (item.Title) {
      case "Job":
        setModuleCreateJob(true);
        break;

      case "Task":
        setModuleCreateTask(true);
        break;

      case "Customer":
        setModuleCreateCustomer(true);
        break;

      case "Supplier":
        setModuleCreateSupplier(true);
        break;

      case "Opportunity":
        setModuleCreateOpportunity(true);
        break;

      case "Invoice":
        history.push("/crmit-invoices-create");
        break;

      case "Purchase":
        history.push("/create-purchase");
        break;

      case "Contract":
        setModuleCreateContract(true);
        break;

      case "Upload Files":
        setModuleUploadFiles(true);
        break;

      case "Email":
        setModuleCreateEmail(true);
        break;

      case "SMS":
        setModuleCreateSms(true);
        break;

      case "Leave Request":
        setModalLeaveRequest(true);
        break;

      case "Create Quote":
        history.push("/create-quote");
        break;

      case "Upload Purchase":
        setModuleUploadPurchase(true);
        break;

      default:
        break;
    }
  };

  return (
    <React.Fragment>
      {modalLeaveRequest && (
        <LeaveRequest
          modalLeaveRequest={modalLeaveRequest}
          setModalLeaveRequest={setModalLeaveRequest}
          togglemodalLeaveRequest={toggleLeaveRequest}
        />
      )}

      {moduleCreateJob && (
        <JobCreateEdit
          modal={moduleCreateJob}
          setModal={setModuleCreateJob}
          toggle={toggleModuleCreateJob}
          isEdit={false}
        />
      )}

      {moduleCreateContract && (
        <CreateContractItem
          modalCreateContractItem={moduleCreateContract}
          setModalCreateContractItem={setModuleCreateContract}
          toggleCreateContractItem={toggleModuleCreateContract}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}

      {moduleCreateSupplier && (
        <CreateSupplier
          modalCreateSupplier={moduleCreateSupplier}
          setModalCreateSupplier={setModuleCreateSupplier}
          toggleCreateSupplier={toggleModuleCreateSupplier}
        />
      )}

      {moduleCreateCustomer && (
        <CreateEditCustomer
          modalCreateCustomer={moduleCreateCustomer}
          setModalCreateCustomer={setModuleCreateCustomer}
          toggleCreateCustomer={toggleModuleCreateCustomer}
        />
      )}

      {moduleCreateTask && (
        <CreateEditTaskPopUp
          modalTask={moduleCreateTask}
          setModalTask={setModuleCreateTask}
          toggleTask={toggleModuleCreateTask}
          isCreate={true}
          isEdit={false}
          standAlone={true}
        />
      )}

      {moduleCreateOpportunity && (
        <CreateEditOpportunityPopUp
          modalOpportunity={moduleCreateOpportunity}
          setModalOpportunity={setModuleCreateOpportunity}
          toggleOpportunity={toggleModuleCreateOpportunity}
          isCreate={true}
          isEdit={false}
          standAlone={true}
        />
      )}

      {moduleUploadFiles && (
        <UploadMultipleFiles
          modal={moduleUploadFiles}
          toggle={toggleModuleUploadFiles}
          setModal={setModuleUploadFiles}
        />
      )}

      {moduleUploadPurchase && (
        <UploadMultipleFiles
          modal={moduleUploadPurchase}
          toggle={toggleModuleUploadPurchase}
          setModal={setModuleUploadPurchase}
          page={"PurchaseListPage"}
        />
      )}

      {moduleCreateEmail && (
        <SendEmail
          modal={moduleCreateEmail}
          setModal={setModuleCreateEmail}
          toggle={toggleModuleCreateEmail}
        />
      )}

      {moduleCreateSms && (
        <SendSms
          modal={moduleCreateSms}
          toggle={toggleModuleCreateSms}
          phoneNumber=""
        />
      )}

      <Dropdown
        isOpen={isMyShortCutsDropdown}
        toggle={toggleIsMyShortCutsDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="fa-solid fa-plus"></i>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg p-0">
          <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
            <Row className="align-items-center">
              {!isEmpty(myShortCutsList) ? (
                <Col>
                  <h6 className="m-0 fw-semibold fs-15">My Create Shortcuts</h6>
                </Col>
              ) : (
                <span>You have no quick shortcuts.</span>
              )}
            </Row>
          </div>

          <div className="dropdown-menu-end" style={{ width: "100%" }}>
            {myShortCutsList
              ?.filter((item) => item.Active)
              ?.map((item) => (
                <DropdownItem
                  key={item.Id}
                  onClick={() => handleShortCutCLick(item)}
                >
                  <div className="d-flex flex-row align-items-center">
                    <span
                      className="d-flex justify-content-center"
                      style={{ width: "35px" }}
                    >
                      <i
                        className={`${item.Icon} text-muted fs-14 align-middle me-1`}
                      ></i>
                    </span>

                    <span className="align-middle">{item.Title}</span>
                  </div>
                </DropdownItem>
              ))}
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
}
